import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { cookie } from '../http/utils'

Vue.use(VueI18n)
let locale = cookie.getCookie('LANG_MODE', 'zh-CN')
if (locale === 'zh') {
  locale = 'zh-CN'
}
export default new VueI18n({
  locale: locale,
  messages: {
    'zh-CN': require('./lang/zh-CN'),
    'en': require('./lang/en')
  }
})
